export const CREATE_ONBE_DOWNTIME_WINDOW_REQUEST = 'CREATE_ONBE_DOWNTIME_WINDOW_REQUEST';
export const CREATE_ONBE_DOWNTIME_WINDOW_SUCCESS = 'CREATE_ONBE_DOWNTIME_WINDOW_SUCCESS';
export const CREATE_ONBE_DOWNTIME_WINDOW_FAILED = 'CREATE_ONBE_DOWNTIME_WINDOW_FAILED';

export const UPDATE_ONBE_DOWNTIME_WINDOW_REQUEST = 'UPDATE_ONBE_DOWNTIME_WINDOW_REQUEST';
export const UPDATE_ONBE_DOWNTIME_WINDOW_SUCCESS = 'UPDATE_ONBE_DOWNTIME_WINDOW_SUCCESS';
export const UPDATE_ONBE_DOWNTIME_WINDOW_FAILED = 'UPDATE_ONBE_DOWNTIME_WINDOW_FAILED';

export const GET_ONBE_DOWNTIME_WINDOW_REQUEST = 'GET_ONBE_DOWNTIME_WINDOW_REQUEST';
export const GET_ONBE_DOWNTIME_WINDOW_SUCCESS = 'GET_ONBE_DOWNTIME_WINDOW_SUCCESS';
export const GET_ONBE_DOWNTIME_WINDOW_FAILED = 'GET_ONBE_DOWNTIME_WINDOW_FAILED';

export const DELETE_ONBE_DOWNTIME_WINDOW_REQUEST = 'DELETE_ONBE_DOWNTIME_WINDOW_REQUEST';
export const DELETE_ONBE_DOWNTIME_WINDOW_SUCCESS = 'DELETE_ONBE_DOWNTIME_WINDOW_SUCCESS';
export const DELETE_ONBE_DOWNTIME_WINDOW_FAILED = 'DELETE_ONBE_DOWNTIME_WINDOW_FAILED';

export const GET_API_DOCUMENTATION_FILE_REQUEST = 'GET_API_DOCUMENTATION_FILE_REQUEST';
export const GET_API_DOCUMENTATION_FILE_SUCCESS = 'GET_API_DOCUMENTATION_FILE_SUCCESS';
export const GET_API_DOCUMENTATION_FILE_FAILED = 'GET_API_DOCUMENTATION_FILE_FAILED';

export const GET_API_DOCUMENTATION_TOKEN_REQUEST = 'GET_API_DOCUMENTATION_TOKEN_REQUEST';
export const GET_API_DOCUMENTATION_TOKEN_SUCCESS = 'GET_API_DOCUMENTATION_TOKEN_SUCCESS';
export const GET_API_DOCUMENTATION_TOKEN_FAILED = 'GET_API_DOCUMENTATION_TOKEN_FAILED';

export const SET_ONBE_DOWNTIME_WINDOW = 'SET_ONBE_DOWNTIME_WINDOW';

export const SET_API_DOCUMENTATION_FILE = 'SET_API_DOCUMENTATION_FILE';
